
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

const PhoneInput: React.FC<PhoneInputProps> = ({ 
  value, 
  onChange, 
  error, 
  label = "Phone Number",
  placeholder = "Enter phone number",
  required = false,
  disabled = false
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    
    // Remove any non-digit, non-space, non-dash, non-parentheses, non-plus characters
    inputValue = inputValue.replace(/[^\d\s\-\(\)\+]/g, '');
    
    // Limit length to prevent abuse
    if (inputValue.length > 20) {
      inputValue = inputValue.substring(0, 20);
    }
    
    onChange(inputValue);
  };

  return (
    <div className="space-y-2">
      {label && <Label htmlFor="phone">{label}</Label>}
      <Input
        id="phone"
        type="tel"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={error ? 'border-red-500' : ''}
        maxLength={20}
        autoComplete="tel"
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default PhoneInput;
